import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";
import services from "../../services";
import Header from "../../components/Header";
import "./styles.scss";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { getListagemBanner } from "../../services/http/bannersServico";
import iconLixeiraListagemSvg from "../../assets/icons/iconLixeiraListagem.svg";
import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import { getIconesExtensao, validarVisualizar } from "../../services/utils";
import iconDownloadCard from "../../assets/icons/iconDownloadCard.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import iconRecentesNovoSvg from "../../assets/icons/iconRecentesNovo.svg";
import restaurado from "../../assets/icons/restaurado.svg";
import iconLink from "../../assets/icons/iconLink.svg";
import menuCopiarCard from "../../assets/icons/menuCopiarCard.svg";
import iconButtonRestaurar from "../../assets/icons/iconButtonRestaurar.svg";
import iconRecentesAlterado from "../../assets/icons/iconRecentesAlterado.svg";
import iconRecentesAlteradoSvg from "../../assets/icons/iconRecentesAlterado.svg";
import iconVisualizar from "../../assets/icons/olho.svg";
import copiar from "../../assets/icons/copiar.svg";
import favorito from "../../assets/icons/favoritos.png";
import estrela from "../../assets/icons/iconEstrela.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { listarAtividadesRecentes } from "../../services/http/atividadeRecenteService";
import { Avatar, Menu, message } from "antd";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconeArquivos from "../../components/IconeArquivos";
import DraftsIcon from "@mui/icons-material/Drafts";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import {
  deletarNotificacoes,
  listarNotificacoes,
  listarTitulosNotificacoes,
  marcarComoLida,
} from "../../services/http/notificacoesService";
export default function PageHome() {
  const [banners, setBanners] = useState([]);
  const [data, setData] = useState([]);
  const [listaNotificacoes, setlistaNotificacoes] = useState([]);
  const [excluirNotificacao, setExcluirNotificacao] = useState("");
  const [detalheNotificacao, setDetalheNotificacao] = useState("");
  const [qtdNotificacoes, setQtdNotificacoes] = useState(0);
  const [dois, setDois] = useState(null);
  const { IdUser, IsAdmin } = services.storage.getUser();
  const listaBanners = () => {
    trackPromise(
      getListagemBanner()
        .then((res) => {
          if (!res.fail && res.data) {
            setBanners([...res.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleListarAtividadeRecentes = (pagina = 1) => {
    trackPromise(
      listarAtividadesRecentes(pagina, 10)
        .then((res) => {
          if (!res.fail && res.data) {
            setData(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const showIniciais = (nome) => {
    if (!nome) {
      return "";
    }

    let nomecompleto = nome.replace(".", " ");
    var iniciais = nomecompleto.match(/\b(\w)/gi);

    if (iniciais == null) {
      return "";
    }

    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase();
    return sobrenomes;
  };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];

    let nomeArquivo =
      !item.nome?.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return (
        <div>
          <img
            src={item.urlPreview}
            style={{
              width: 112,
              height: 112,
            }}
          />
        </div>
      );
    } else {
      return (
        <img
          src={getIconesExtensao(extensao)}
          style={{
            maxHeight: "1.5rem",
            maxWidth: "1.5rem",
            marginRight: "5px",
          }}
        />
      );
    }
  };
  const imagemNovoAlteradoExcluido = (descricao) => {
    if (String(descricao).includes("restaurado")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={restaurado} />
      );
    }
    if (String(descricao).includes("obter link")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={iconLink} />
      );
    }
    if (String(descricao).includes("compartilhar")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={menuCompartilhar}
        />
      );
    }
    if (String(descricao).includes("download")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconDownloadCard}
        />
      );
    }
    if (
      String(descricao).includes("copiar pasta") ||
      String(descricao).includes("copiar arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={menuCopiarCard}
        />
      );
    }
    if (
      String(descricao).includes("mover pasta") ||
      String(descricao).includes("mover arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconButtonRestaurar}
        />
      );
    }
    if (
      String(descricao).includes("editar pasta") ||
      String(descricao).includes("editar permissão") ||
      String(descricao).includes("editar arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlterado}
        />
      );
    }
    if (String(descricao).includes("visualizar")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconVisualizar}
        />
      );
    }
    if (
      String(descricao).includes("renomear pasta") ||
      String(descricao).includes("renomear arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlterado}
        />
      );
    }
    if (
      String(descricao).includes("novo") ||
      String(descricao).includes("nova")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesNovoSvg}
        />
      );
    }

    if (
      String(descricao).includes("alterado") ||
      String(descricao).includes("alterada")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlteradoSvg}
        />
      );
    }

    if (
      String(descricao).includes("excluido") ||
      String(descricao).includes("exclusão de arquivo") ||
      String(descricao).includes("exclusão de pasta")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconLixeiraListagemSvg}
        />
      );
    }
    if (
      String(descricao).includes("copiar pasta") ||
      String(descricao).includes("copiar pasta")
    ) {
      return <img style={{ width: "1.5rem", height: "1.5rem" }} src={copiar} />;
    }
    if (
      String(descricao).includes("favoritar arquivo") ||
      String(descricao).includes("favoritar pasta")
    ) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={favorito} />
      );
    }
    if (String(descricao).includes("editar classificação")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={estrela} />
      );
    }
  };
  function transformaData(inputData) {
    const dataEnvio = new Date(inputData);
    // Obtém a data e hora atuais com o ajuste de fuso horário
    const agora = new Date(
      new Date().toLocaleString("en-US", { timeZone: "UTC" })
    );
    const diferencaTempo = agora - dataEnvio;

    if (diferencaTempo < 23 * 60 * 60 * 1000) {
      return `${tempoPassado(diferencaTempo)}`;
    } else if (diferencaTempo < 24 * 60 * 60 * 1000) {
      return `${formatarHora(dataEnvio)}`;
    } else if (diferencaTempo < 7 * 24 * 60 * 60 * 1000) {
      return `${Math.floor(diferencaTempo / (24 * 60 * 60 * 1000))} d`;
    } else {
      return `${formatarDataHora(dataEnvio)}`;
    }
  }
  const linkNot = (link) => {
    window.open(link, "_blank");
  };
  const fnDeletarNotificacoes = (id) => {
    setDois(false);
    trackPromise(
      deletarNotificacoes(id)
        .then((res) => {
          listaNotificacoesSino();
          setExcluirNotificacao("");
          message.success("Notificação deletada!");
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  function formatarHora(data) {
    return `${("0" + (data.getHours() - 3)).slice(-2)}:${(
      "0" + data.getMinutes()
    ).slice(-2)}`;
  }

  function formatarDataHora(data) {
    return `${("0" + data.getDate()).slice(-2)}/${(
      "0" +
      (data.getMonth() + 1)
    ).slice(-2)} - ${formatarHora(data)}`;
  }
  function tempoPassado(diferenca) {
    const minutos = Math.floor(diferenca / (60 * 1000));

    if (minutos < 60) {
      return `${minutos} min`;
    } else if (minutos < 120) {
      return "1h";
    } else {
      const horas = Math.floor(minutos / 60);
      return `${horas} h`;
    }
  }
  const listaNotificacoesSino = () => {
    trackPromise(
      listarTitulosNotificacoes(IdUser)
        .then((res) => {
          if (!res.fail && res.data) {
            setlistaNotificacoes(res.data);
            const naoVisualizadas = res.data.filter(
              (notificacao) => !notificacao.visualizado
            );

            setQtdNotificacoes(naoVisualizadas.length);
          }

          // setNovaEdit(false);
        })
        .catch((error) => {
          console.error(error);
          // setlistaNotificacoes([{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'}]);
        })
    );
  };
  const fnMarcarComoLida = (id, link) => {
    if (link.indexOf("ListaPastasArquivosNotificacao") > 0) return;

    setDois(false);
    trackPromise(
      marcarComoLida(id)
        .then((res) => {
          listaNotificacoesSino();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  useEffect(() => {
    listaNotificacoesSino();
    listaBanners();
    handleListarAtividadeRecentes();
  }, []);
  return (
    <>
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />
      <Swiper
        autoplay={100}
        navigation={true}
        pagination={true}
        keyboard={true}
        modules={[Navigation, Pagination]}
        className="mySwiper"
      >
        {banners?.map((e, i) => (
          <SwiperSlide key={i}>
            <a href={e.link} target="_blank">
              <img width={"100%"} src={e.urlArquivo} />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="container mt-5 ">
        <div className="row">
          <div className="col-md-6">
            <h2>ATIVIDADES RECENTES</h2>

            {data?.lista?.length > 0 ? (
              data?.lista?.map((item, i) => (
                <div key={i} style={{ width: "100%", minHeight: 140 }}>
                  {item?.atividadesRecentes?.map(
                    (atividade, index) =>
                      index <= 2 && (
                        <>
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "column",
                              backgroundColor: "#e7e7e7",
                              marginTop: 16,
                              padding: 5,
                              borderRadius: 10,
                              border: "solid #aaa 1px",
                              minHeight: 140,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                marginBottom: -20,
                                width: "100%",
                                color: "red",
                                textAlign: "right",
                                fontSize: 12,
                                padding: " 0 10px",
                              }}
                            >
                              {transformaData(atividade.dataAlteracao)}
                            </div>

                            <div
                              style={{
                                display: "flex",
                              }}
                            >
                              <div
                                key={index}
                                className="container-info-icone p-2"

                                // onClick={() => {
                                //   handleAbrirOuVisualizar(atividade);
                                // }}
                              >
                                {atividade.tipo == 0 ? (
                                  <img src={infoPastaSvg} />
                                ) : (
                                  preImagemArquivo(atividade)
                                )}
                              </div>
                              <div
                                className="container-info-detalhes pr-5"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  // fnDirecionamento(atividade);
                                }}
                              >
                                <span>
                                  {imagemNovoAlteradoExcluido(
                                    String(
                                      atividade.descricaoAtividade
                                    ).toLowerCase()
                                  )}
                                  <span style={{ marginLeft: "0.5rem" }}>
                                    {atividade.descricaoAtividade}
                                  </span>
                                </span>
                                <span className="span-avatar">
                                  <Avatar
                                    size={"small"}
                                    style={{
                                      background: "#0042DD",
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    {showIniciais(atividade.autor)}
                                  </Avatar>
                                  <span style={{ marginLeft: "0.5rem" }}>
                                    {atividade.autor}
                                  </span>
                                </span>
                                {
                                  <span
                                    className="span-imagem-arquivo-pasta"
                                    style={{
                                      display: "flex",
                                      width: "100%",
                                      alignItems: "center",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {atividade.tipo == 0 ? (
                                      <img
                                        src={infoPastaSvg}
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                        }}
                                      />
                                    ) : (
                                      <IconeArquivos
                                        tamanho={"P"}
                                        tipo={
                                          String(atividade.nomeDocumento).split(
                                            "."
                                          )[1]
                                        }
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                        }}
                                      />
                                    )}
                                    <span
                                      style={{
                                        marginLeft: "0.5rem",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        width: "50%",
                                      }}
                                    >
                                      {atividade.nomeDocumento}
                                    </span>
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                        </>
                      )
                  )}
                </div>
              ))
            ) : (
              <div>Lista vazia</div>
            )}
          </div>

          <div className="col-md-6">
            <h2>ÚLTIMAS NOTIFICAÇÕES</h2>
            {listaNotificacoes?.length > 0 ? (
              listaNotificacoes && (
                <div>
                  {listaNotificacoes &&
                    listaNotificacoes.map((notificacao, index) =>
                      notificacao.id === excluirNotificacao ? (
                        <div
                          style={{
                            marginTop: 16,
                            minHeight: 140,
                            cursor: "default",
                          }}
                          key={index}
                        >
                          <div
                            style={{
                              color: "red",
                              textAlign: "right",
                              fontSize: 12,
                            }}
                          ></div>
                          <div className="d-flex justify-content-center  ">
                            <div
                              style={{
                                fontWeight: 900,
                              }}
                            >
                              Deseja realmente excluir a notificação?
                            </div>
                          </div>

                          <div
                            style={{
                              padding: 5,
                              fontWeight: notificacao.visualizado ? 400 : 900,
                            }}
                          >
                            <div className="d-flex justify-content-center w-100 mt-3 ">
                              <button
                                className="btn btn-primary btn-sm mx-3 "
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setExcluirNotificacao("");
                                }}
                              >
                                Não
                              </button>
                              <button
                                className="btn btn-danger btn-sm mx-3 "
                                onClick={(e) => {
                                  e.stopPropagation();
                                  fnDeletarNotificacoes(notificacao.id);
                                }}
                              >
                                Sim
                              </button>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            marginTop: 16,
                            minHeight: 140,
                            cursor:
                              notificacao.link == null ||
                              notificacao.link == "" ||
                              notificacao.link == undefined
                                ? "default"
                                : "pointer",
                            backgroundColor: "#e7e7e7",
                            padding: 5,
                            borderRadius: 10,
                            border: "solid #aaa 1px",
                          }}
                          key={index}
                          onClick={(e) => {
                            if (
                              notificacao.link !== null &&
                              notificacao.link !== "" &&
                              notificacao.link !== undefined
                            ) {
                              linkNot(notificacao.link);
                            }
                          }}
                        >
                          <div>
                            <div
                              style={{
                                color: "red",
                                textAlign: "right",
                                fontSize: 12,
                                padding: " 0 10px",
                              }}
                            >
                              {transformaData(notificacao.dataEnvioUtc)}
                            </div>
                            <div className="d-flex align-items-center justify-content-between ">
                              <div
                                className="d-flex  align-items-center"
                                style={{ maxWidth: 300 }}
                              >
                                {notificacao.visualizado ? (
                                  <DraftsIcon
                                    style={{
                                      marginRight: 10,
                                      marginLeft: 20,
                                      color: "red",
                                    }}
                                  />
                                ) : (
                                  <MarkunreadIcon
                                    style={{
                                      marginRight: 10,
                                      color: "red",
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    fontWeight: notificacao.visualizado
                                      ? 400
                                      : 900,
                                  }}
                                >
                                  {notificacao.titulo}
                                </div>
                              </div>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setExcluirNotificacao(notificacao.id);
                                }}
                              >
                                <HighlightOffIcon
                                  style={{
                                    color: "#aaa",
                                    margin: "0 10px",
                                  }}
                                />
                              </div>
                            </div>
                            <div
                              className="d-flex align-items-start justify-content-between "
                              style={{ width: "100%" }}
                            >
                              {notificacao.id === detalheNotificacao ? (
                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    fontWeight: 400,
                                    whiteSpace: "normal",
                                    textOverflow: "initial",
                                    overflow: "auto",
                                    padding: "10px 20px",
                                  }}
                                >
                                  {notificacao.subtitulo}
                                </div>
                              ) : (
                                <div
                                  style={{
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",

                                    width: "100%",
                                    padding: "10px 20px",
                                    fontWeight: 400,
                                  }}
                                >
                                  {notificacao.subtitulo}
                                </div>
                              )}
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDetalheNotificacao(
                                    notificacao.id !== detalheNotificacao
                                      ? notificacao.id
                                      : ""
                                  );
                                  if (notificacao.visualizado == false) {
                                    fnMarcarComoLida(notificacao.id, notificacao.link);
                                  }

                                  const newNotificacoes = [
                                    ...listaNotificacoes,
                                  ];
                                  newNotificacoes[index].verDetalhe =
                                    !newNotificacoes[index].verDetalhe;
                                  setlistaNotificacoes(newNotificacoes);
                                }}
                              >
                                <div
                                  style={{
                                    color: "#aaa",
                                    margin: "0 10px",
                                    transform:
                                      notificacao.id === detalheNotificacao
                                        ? "rotate(180deg)"
                                        : "rotate(0deg)",
                                  }}
                                >
                                  <ExpandCircleDownIcon />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                </div>
              )
            ) : (
              <div>Lista vazia</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
